import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../services/axios";

import Select from '../../components/form/Select';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css"; 
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getAvatarColor, getCallStatusColor, getInitials } from "../../Helpers/common";

export default function Admin() {

    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const [dateRange, setDateRange] = useState([new Date(), null]);
    const [activeCallType, setActiveCallType] = useState("ALL"); 
    const [startDate, endDate] = dateRange;
    const [dateFilter, setDateFilter] = useState("today");

    const [callStats, setCallStats] = useState({
        total: 0,
        outgoing: 0,
        missed: 0,
        incoming: 0
      });

       const [callHistory, setCallHistory] = useState([]);
        useEffect(() => {
          const todayRange = getDateRangeForFilter("today");
          setDateRange(todayRange);
       
        }, []);

         const callhis = async () => {
            try{
              console.log("Fetching call history for date range:", dateRange);
              let get = await axios.get(`/call-collections?limit=10&page=1&startDate=${moment(dateRange[0]).format("YYYY-MM-DD")}&endDate=${moment(dateRange[1]).format("YYYY-MM-DD")}`);
              setCallHistory(get.data.data.data || []);
            }catch(error){
              console.error('Error fetching call history:', error);
              toast.error("Failed to fetch call history");
              setCallHistory([]);
            }
          }
          const callCountStats = async()=>{
              let get = await axios.get(`/call-collections/count/calls?startDate=${moment(dateRange[0]).format("YYYY-MM-DD")}&endDate=${moment(dateRange[1]).format("YYYY-MM-DD")}`);
              // setCallStats(get.data.data.data || {
              //   total: 0,
              //   answered: 0,
              //   missed: 0,
              //   duration: 0
              // });
              if(get.data.data.data){
                setCallStats({
                  total: parseInt(get.data.data.data.OUTGOING)+parseInt(get.data.data.data.INCOMING)+parseInt(get.data.data.data.MISSED)+parseInt(get.data.data.data.UNKNOWN || 0) || 0,

                  outgoing: parseInt(get.data.data.data.OUTGOING) || 0,
                  missed: parseInt(get.data.data.data.MISSED) || 0,
                  incoming: parseInt(get.data.data.data.INCOMING) || 0
                })
              }
          }
            useEffect(()=>{
              callhis();
              callCountStats();
            },[dateRange,setDateFilter])
const getDateRangeForFilter = (filter) => {
    const today = moment();
    switch (filter) {
      case "today":
        return [today.toDate(), today.toDate()];
      case "week":
        const startOfWeek = today.clone().startOf("week");
        const endOfWeek = today.clone().endOf("week");
        return [startOfWeek.toDate(), endOfWeek.toDate()];
      case "custom":
        return dateRange;
      default:
        return [today.toDate(), today.toDate()];
    }
  };
   const handleDateFilterChange = (filter) => {
    setDateFilter(filter);
    if (filter !== 'custom') {
      const newRange = getDateRangeForFilter(filter);
      setDateRange(newRange);
    }
  };
  const dateFilterOptions = [
    { id: 0, name: "Today", value: "today" },
    { id: 1, name: "This Week", value: "week" },
    { id: 2, name: "Custom Range", value: "custom" },
  ];
    const getFilteredCalls = () => {
      const [filterStart, filterEnd] = dateRange;
      
      if (!filterStart) return callHistory;
      
      const startOfDay = moment(filterStart).startOf('day');
      const endOfDay = filterEnd ? moment(filterEnd).endOf('day') : moment(filterStart).endOf('day');
      
      return callHistory.filter(call => {
        const callDate = moment(call.date);
        return callDate.isBetween(startOfDay, endOfDay, null, '[]');
      });
    };
     const filteredCalls = getFilteredCalls();
  const userName = user?.name || "User";
  console.log(callStats);
  return (
  <>
   <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white py-4 px-6 rounded-lg mb-4">
        <div className="flex items-center justify-between sm:flex-col flex-col md:flex-row">
          <div className="w-full">
            <h2 className="text-2xl font-bold">Hello, {userName}! 👋</h2>
            <p className="text-blue-100 mt-1">
              Welcome back! Here's your call history overview.
            </p>
          </div>
          <div className="text-right w-full">
           <div className='flex justify-end items-center gap-3'>
            {/* Call Type Filter */}
            {/* Date Filter Dropdown */}
            <div className='flex justify-end items-center gap-3'>
              <Select
               className="w-40"
                options={dateFilterOptions.map(option => ({ value: option.value, label: option.name }))}
                value={dateFilter}
                onChange={(selected) => handleDateFilterChange(selected)}
              />
            </div>
            
            {/* Custom Date Picker - Only show when Custom is selected */}
            {dateFilter === 'custom' && (
              <div className='flex justify-end items-center gap-3'>
                <DatePicker
                  className='p-3 rounded-lg border text-dark border-gray-300'
                  selectsRange={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => {
                      setDateRange(update);
                  }}
                  isClearable={true}
                  placeholderText="Select date range"
                />
              </div>
            )}
          </div>
          </div>
        </div>
      </div>
       {/* Stats Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {/* Total Calls */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm border-l-4 border-blue-500">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Total Calls</p>
            <p className="text-3xl font-bold text-gray-900 dark:text-white">{callStats.total}</p>
          </div>
          <div className="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-full">
            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
          </div>
        </div>
      </div>

      {/* Successful Calls */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm border-l-4 border-green-500">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">OUTGOING</p>
            <p className="text-3xl font-bold text-gray-900 dark:text-white">
              {callStats.outgoing}
            </p>
          </div>
          <div className="p-3 bg-green-100 dark:bg-green-900/30 rounded-full">
            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>
        
      </div>

      {/* Missed Calls */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm border-l-4 border-red-500">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">MISSED</p>
            <p className="text-3xl font-bold text-gray-900 dark:text-white">
              {callStats.missed}
            </p>
          </div>
          <div className="p-3 bg-red-100 dark:bg-red-900/30 rounded-full">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>
      </div>

      {/* Total Tasks */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm border-l-4 border-purple-500">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">INCOMMING</p>
            <p className="text-3xl font-bold text-gray-900 dark:text-white">{callStats.incoming}</p>
          </div>
          <div className="p-3 bg-purple-100 dark:bg-purple-900/30 rounded-full">
            {/* Incoming Call Icon */}
            <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 2v6a1 1 0 01-1 1h-6m8-7l-9 9m-2 2a7 7 0 11-9.9 9.9 7 7 0 019.9-9.9z" />
            </svg>
          </div>
        </div>
       
      </div>
    </div>
    
        {/* Recent Calls Table */}
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm mt-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Recent Calls ({filteredCalls.length})
            </h3>
            {/* <button onClick={(()=>navigate('/employee/calls-history'))} className="text-blue-600 hover:text-blue-700 text-sm font-medium">View All</button> */}
          </div>
          
          {filteredCalls.length === 0 ? (
            <div className="text-center py-12">
              <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No calls found</h3>
              <p className="text-gray-600 dark:text-gray-400">No calls match your current filter criteria.</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full table-auto">
                <thead>
                  <tr className="border-b border-gray-200 dark:border-gray-700">
                     <th className="text-left py-3 px-4 font-semibold text-sm text-gray-600 dark:text-gray-400">Counselor</th>
                    <th className="text-left py-3 px-4 font-semibold text-sm text-gray-600 dark:text-gray-400">Contact</th>
                    <th className="text-left py-3 px-4 font-semibold text-sm text-gray-600 dark:text-gray-400">Phone</th>
                    <th className="text-left py-3 px-4 font-semibold text-sm text-gray-600 dark:text-gray-400">Duration</th>
                    <th className="text-left py-3 px-4 font-semibold text-sm text-gray-600 dark:text-gray-400">Status</th>
                    <th className="text-left py-3 px-4 font-semibold text-sm text-gray-600 dark:text-gray-400">Time</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCalls.map((call) => (
                    <tr key={call.id} className="border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                       <td className="py-3 px-4">
                        <div className="flex items-center">
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${getAvatarColor('blue')}`}>
                            <span className="text-sm font-semibold">{getInitials(call.employee.name)}</span>
                          </div>
                          <span className="font-medium text-gray-900 dark:text-white">{call.employee.name}</span>
                        </div>
                      </td>
                      <td className="py-3 px-4">
                        <div className="flex items-center">
                          {/* <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${getAvatarColor('blue')}`}>
                            <span className="text-sm font-semibold">{getInitials(call.callName)}</span>
                          </div> */}
                          <span className="font-medium text-gray-900 dark:text-white">{call.callName}</span>
                        </div>
                      </td>
                      <td className="py-3 px-4 text-gray-600 dark:text-gray-400">{call.number}</td>
                      <td className="py-3 px-4 text-gray-600 dark:text-gray-400">{ moment.utc(call.callDuration * 1000).format('HH:mm:ss')}</td>
                      <td className="py-3 px-4">
                        <span className={`px-2 py-1 text-xs font-semibold rounded-full capitalize ${getCallStatusColor(call.callType)}`}>
                          {call.callType}
                        </span>
                      </td>
                      <td className="py-3 px-4 text-gray-600 dark:text-gray-400">
                        {(() => {
                          // Ensure timestamp is parsed as a number
                          const m = moment(Number(call.callTimeStamp));
                          if (!m.isValid()) return '';
                          if (m.isSame(moment(), 'day')) {
                            return m.fromNow(); // e.g. 'a few minutes ago', 'an hour ago'
                          } else if (m.isSame(moment().subtract(1, 'day'), 'day')) {
                            return 'Yesterday';
                          } else if (m.isAfter(moment().subtract(7, 'days'))) {
                            return m.format('dddd'); // e.g. 'Monday'
                          } else {
                            return m.format('MMM DD, YYYY');
                          }
                        })()}
                      </td>
                    
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
  </>
  )
}
